import { render, staticRenderFns } from "./TOOL_ANNOUNCEMENTS_INFO.vue?vue&type=template&id=461f701f&scoped=true"
import script from "./TOOL_ANNOUNCEMENTS_INFO.vue?vue&type=script&lang=ts"
export * from "./TOOL_ANNOUNCEMENTS_INFO.vue?vue&type=script&lang=ts"
import style0 from "./TOOL_ANNOUNCEMENTS_INFO.vue?vue&type=style&index=0&id=461f701f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f701f",
  null
  
)

export default component.exports